module.exports = __webpack_public_path__ + "static/img/506.2a302eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/506.png
// module id = 535
// module chunks = 3